var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import DOMPurify from "dompurify";
export default function ProductUpdate(props) {
    var _a, _b, _c, _d, _e;
    const { item, setItem, menu } = props;
    const menes = menu.filter((val) => (val.url !== Const.URL_PRODUCTS));
    const [itemClass, setItemClass] = useState("");
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [content, setContent] = useState("");
    const [summary, setSummary] = useState("");
    const [files, setFiles] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const [reset, setRest] = useState(false);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    let token = localStorage.getItem(Const.TOKEN);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/item/${item.id}/detail`,
        appQuery: {},
        userToken: token,
        watch: reset,
    });
    useEffect(() => {
        var _a, _b;
        if (data) {
            if (data.codeNum == Const.API_200) {
                const raw = (_a = data.body.content) !== null && _a !== void 0 ? _a : "";
                const safe = DOMPurify.sanitize(raw, {
                    ALLOWED_TAGS: [],
                    ALLOWED_ATTR: [], // 필요하면 여기에 추가: class, id 등
                });
                const raw1 = (_b = data.body.summary) !== null && _b !== void 0 ? _b : "";
                const safe1 = DOMPurify.sanitize(raw1, {
                    ALLOWED_TAGS: [],
                    ALLOWED_ATTR: [], // 필요하면 여기에 추가: class, id 등
                });
                setItemClass(data.body.itemClass);
                setTitle(data.body.title);
                setSubTitle(data.body.subTitle);
                setContent(safe);
                setSummary(safe1);
                setFiles(data.body.fileList.map((item) => (Object.assign(Object.assign({}, item), { isImg: item.sort === 1 ? true : false }))));
                setIsActive(data.body.isActive);
                setRest(false);
            }
        }
    }, [data]);
    // 환면전환
    const handleView = (type) => {
        setItem(Object.assign(Object.assign({}, item), { type: type }));
    };
    // 제품구분
    const selects = (e) => {
        const selectedLang = e.target.value;
        setItemClass(selectedLang);
    };
    // 버튼 클릭 시 input 만들기
    const handleUpload = (sort) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.multiple = false; // ★ 멀티 업로드 ON
        input.onchange = (e) => {
            const target = e.currentTarget;
            const selectedFiles = target.files;
            if (!selectedFiles)
                return;
            // 여러 개 들어오면 한 번에 처리
            for (const file of selectedFiles) {
                handleSelectFile(file, sort);
            }
        };
        input.click();
    };
    // 첨부파일 처리
    const handleSelectFile = (file, sort) => {
        let copy = [...files];
        const formData = new FormData();
        formData.append("files", file);
        //  대표(sort:1)는 하나만 허용
        if (sort === 1) {
            const exists = copy.find(f => f.sort === 1);
            if (exists) {
                alert("대표 이미지는 하나만 업로드 가능합니다.");
                return;
            }
        }
        //  상세(sort:2~5)는 총 4개 제한
        if (sort !== 1) {
            const subImages = copy.filter(f => f.sort !== 1);
            if (subImages.length >= 4) {
                alert("상세 이미지는 최대 4장까지 업로드 가능합니다.");
                return;
            }
        }
        //  상태에 저장할 객체 통일
        const newItem = {
            originalFileName: file.name,
            url: URL.createObjectURL(file),
            sort: sort,
            formData: formData
        };
        setFiles([...files, newItem]);
    };
    //이미지 삭제
    const handleImaDel = (e, fileId, sort) => __awaiter(this, void 0, void 0, function* () {
        if (fileId) {
            var isOk = confirm(`해당 파일을 삭제하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            data = yield PromiseHttp({
                httpMethod: Const.API_DELETE,
                appPath: `/admin/file/${fileId}`,
                appQuery: {},
                userToken: token,
            });
            if (data) {
                if (data.codeNum == Const.API_200) {
                    alert("삭제되었습니다.");
                    setRest(true);
                }
                else {
                    alert(data.body.message);
                }
            }
        }
        else {
            setFiles(files.filter((item) => (item.sort != sort)));
        }
    });
    const ProductUpdates = (e) => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`해당 제품을 수정하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_PUT,
            appPath: `/admin/item/${item.id}`,
            appQuery: {
                "title": title,
                "subTitle": subTitle,
                "content": content,
                "summary": summary,
                "itemClass": itemClass,
                "isActive": isActive,
                "lang": lang
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                if (files.filter((item) => (!item.fileId)).length > 0) {
                    fileAdd(item.id, files.filter((val) => (!val.feileId)));
                }
                else {
                    alert("수정되었습니다.");
                    handleView(Const.TYPE_V);
                    location.reload();
                }
            }
            else {
                alert(data.body.message);
            }
        }
    });
    // 첨부파일
    const fileAdd = (itemId, item) => __awaiter(this, void 0, void 0, function* () {
        //  업로드용 FormData 생성
        let data = [];
        let success = [];
        let fail = [];
        for (let i = 0; i < item.length; i++) {
            data = yield PromiseHttp({
                httpMethod: Const.API_POST,
                appPath: `/admin/file/item/${itemId}?sort=${item[i].sort}`,
                appQuery: item[i].formData,
                userToken: token,
            });
            if (data) {
                if (data.codeNum == Const.API_200) {
                    success.push(data.body);
                }
                else {
                    fail.push(item[i].sort);
                }
            }
        }
        if (data) {
            if (success.length > 0) {
                alert("제품이 등록 되었습니다.");
                location.reload();
            }
            else if (fail.length > 0) {
                // need error handle
                alert(`첨부파일을 ${fail.length} 건이 실패하였지만,\n제품은 등록 되었습니다.`);
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "product-detail" }, { children: [_jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC81C\uD488\uAD6C\uBD84" }), _jsx("select", Object.assign({ value: itemClass, onChange: (e) => selects(e) }, { children: menes && menes.map((val) => (_jsx("option", Object.assign({ value: val.menuName }, { children: val.menuName }), val.menuId))) }))] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uBA54\uC778\uC0AC\uC9C4" }), ((_a = files.filter((file) => (file.sort == 1))[0]) === null || _a === void 0 ? void 0 : _a.isImg) ?
                            _jsxs("div", Object.assign({ className: "file-item" }, { children: [_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, { children: [_jsx("g", Object.assign({ clipPath: "url(#clip0_534_749)" }, { children: _jsx("path", { d: "M4.71671 11.1121C6.77744 9.06278 8.3894 7.42464 10.1824 5.66612C10.7744 5.04786 11.1493 4.44275 11.3071 3.8508C11.5834 2.73373 11.1586 1.7664 10.4192 1.00943C9.70885 0.299086 8.94917 -0.0363506 8.14017 0.00311604C6.92667 0.062316 6.53205 0.450376 5.74277 1.22649L0.711163 6.2778L1.5399 7.08679L6.5715 2.05521C7.0878 1.56434 7.7022 1.10156 8.40655 1.16728C9.47972 1.31794 10.4275 2.63144 10.1824 3.55482C9.87171 4.37406 9.44337 4.74771 8.85053 5.34053C7.04712 7.13933 5.64097 8.53036 3.888 10.2833C3.2292 10.8853 2.80314 11.0483 2.19108 10.4806C1.87538 10.1649 1.73725 9.85579 1.77671 9.55325C1.8205 9.20024 2.02034 8.95608 2.25026 8.72452L6.84774 4.12702C7.05777 3.91662 7.5361 3.51277 7.73567 3.69293C7.88878 4.04814 7.49447 4.38718 7.30159 4.58086L3.07899 8.80345L3.88798 9.63219L8.1303 5.40961C8.86099 4.65596 9.38596 3.73501 8.56439 2.88395C7.65577 2.10407 6.69856 2.62472 6.019 3.29832L1.42152 7.8958C0.947963 8.36935 0.678299 8.88238 0.612533 9.43488C0.560653 10.2094 0.909863 10.8312 1.38206 11.3094C1.82591 11.7508 2.30542 11.9953 2.90142 12C3.61798 11.9713 4.32254 11.4993 4.71671 11.1121Z", fill: "#0048ff" }) })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_534_749" }, { children: _jsx("rect", { width: "12", height: "12", fill: "white" }) })) })] })), _jsx("span", Object.assign({ className: "file-name" }, { children: (_b = files.filter((file) => (file.sort == 1))[0]) === null || _b === void 0 ? void 0 : _b.originalFileName })), _jsx("button", Object.assign({ className: "remove-btn", type: "button", onClick: (e) => { var _a; return handleImaDel(e, (_a = files.filter((file) => (file.sort == 1))[0]) === null || _a === void 0 ? void 0 : _a.fileId, 1); } }, { children: "\u2715" }))] })) :
                            _jsxs(_Fragment, { children: [_jsx("input", { type: "text", value: (_c = files.filter((file) => (file.sort == 1))[0]) === null || _c === void 0 ? void 0 : _c.originalFileName }), _jsx("button", Object.assign({ className: "img-btn" }, { children: "\uD30C\uC77C \uC120\uD0DD" }))] })] })), _jsx("div", Object.assign({ className: "main-photo-wrap" }, { children: _jsx("div", Object.assign({ className: "main-photo-preview", id: "mainPhotoPreview" }, { children: ((_d = files.filter((file) => (file.sort == 1))[0]) === null || _d === void 0 ? void 0 : _d.fileId) ?
                            _jsx("img", { src: (_e = files.filter((file) => (file.sort == 1))[0]) === null || _e === void 0 ? void 0 : _e.url, alt: "" })
                            : _jsx("p", { children: "\uC774\uBBF8\uC9C0\uB97C \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4." }) })) })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC81C \uBAA9" }), _jsx("input", { type: "text", value: title || "", onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC18C \uC81C\uBAA9" }), _jsx("input", { type: "text", value: subTitle || "", onChange: (e) => setSubTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uB0B4 \uC6A9" }), _jsx("textarea", { value: content || "", onChange: (e) => setContent(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC694\uC57D\uC124\uBA85" }), _jsx("textarea", { value: summary || "", onChange: (e) => setSummary(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), _jsx("button", Object.assign({ className: "img-btn", onClick: (e) => handleUpload(files.filter((file) => (file.sort !== 1)).length + 2) }, { children: "\uD30C\uC77C \uC120\uD0DD" })), _jsx("p", Object.assign({ className: "file-info" }, { children: "\uCCA8\uBD80\uD30C\uC77C\uC740 4\uAC1C \uC774\uD558, \uC804\uCCB4 120MB\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4." })), _jsx("div", Object.assign({ className: "file-row" }, { children: files.filter((file) => (file.sort !== 1)).map((file, i) => (_jsxs("div", Object.assign({ className: "file-item" }, { children: [_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" }, { children: [_jsx("g", Object.assign({ clipPath: "url(#clip0_534_749)" }, { children: _jsx("path", { d: "M4.71671 11.1121C6.77744 9.06278 8.3894 7.42464 10.1824 5.66612C10.7744 5.04786 11.1493 4.44275 11.3071 3.8508C11.5834 2.73373 11.1586 1.7664 10.4192 1.00943C9.70885 0.299086 8.94917 -0.0363506 8.14017 0.00311604C6.92667 0.062316 6.53205 0.450376 5.74277 1.22649L0.711163 6.2778L1.5399 7.08679L6.5715 2.05521C7.0878 1.56434 7.7022 1.10156 8.40655 1.16728C9.47972 1.31794 10.4275 2.63144 10.1824 3.55482C9.87171 4.37406 9.44337 4.74771 8.85053 5.34053C7.04712 7.13933 5.64097 8.53036 3.888 10.2833C3.2292 10.8853 2.80314 11.0483 2.19108 10.4806C1.87538 10.1649 1.73725 9.85579 1.77671 9.55325C1.8205 9.20024 2.02034 8.95608 2.25026 8.72452L6.84774 4.12702C7.05777 3.91662 7.5361 3.51277 7.73567 3.69293C7.88878 4.04814 7.49447 4.38718 7.30159 4.58086L3.07899 8.80345L3.88798 9.63219L8.1303 5.40961C8.86099 4.65596 9.38596 3.73501 8.56439 2.88395C7.65577 2.10407 6.69856 2.62472 6.019 3.29832L1.42152 7.8958C0.947963 8.36935 0.678299 8.88238 0.612533 9.43488C0.560653 10.2094 0.909863 10.8312 1.38206 11.3094C1.82591 11.7508 2.30542 11.9953 2.90142 12C3.61798 11.9713 4.32254 11.4993 4.71671 11.1121Z", fill: "#0048ff" }) })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_534_749" }, { children: _jsx("rect", { width: "12", height: "12", fill: "white" }) })) })] })), _jsx("span", Object.assign({ className: "file-name" }, { children: file.originalFileName })), _jsx("button", Object.assign({ className: "remove-btn", type: "button", onClick: (e) => handleImaDel(e, file.fileId, file.sort) }, { children: "\u2715" }))] }), "img_" + i.toString()))) }))] })), _jsxs("div", Object.assign({ className: "form-row preview-row" }, { children: [_jsx("label", { children: "\uBBF8\uB9AC\uBCF4\uAE30" }), _jsx("div", Object.assign({ className: "preview-area" }, { children: files.filter((file) => (file.sort !== 1)).length > 0 ?
                                files.filter((file) => (file.sort !== 1)).map((file, idx) => (_jsx("img", { src: file.url, alt: "" }, "view" + idx.toString()))) :
                                _jsx("p", { children: "\uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD558\uBA74 \uC774\uACF3\uC5D0 \uBBF8\uB9AC\uBCF4\uAE30\uAC00 \uD45C\uC2DC\uB429\uB2C8\uB2E4." }) }))] })), _jsxs("div", Object.assign({ className: "detail-footer-row" }, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", checked: isActive, onChange: (e) => setIsActive(e.target.checked) }), " \uC81C\uD488\uD65C\uC131\uD654"] }), _jsxs("div", Object.assign({ className: "btn-group" }, { children: [_jsx("button", Object.assign({ className: "edit-btn", onClick: (e) => ProductUpdates(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ className: "delete-btn", onClick: (e) => handleView(Const.TYPE_L) }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
